import React, { ComponentPropsWithRef, FC } from 'react';
import { useAuthModal } from '@auth/business/AuthModal.hook';
import { PrimaryButton, SecondaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Text } from '@components/Text/Text.component';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { urlEnum } from '@utils/url';
import classnames from 'classnames';

import './Comment.scss';

const CommentsNotLoggedIn: FC<ComponentPropsWithRef<'div'>> = ({ className, ...rest }) => {
  const rootClass = classnames('comments-not-logged-in', className);
  const { showSignInModal } = useAuthModal();

  const isButtonSmall = useIsBreakpointDown(Breakpoint.l);

  return (
    <div className={rootClass} {...rest}>
      <Text
        alignment="center"
        className="comment-not-logged-in-text"
        i18nKey="actu.comments.not-logged-in"
        tag="div"
        variant="p"
      />
      <div>
        <PlcAnchor linkProps={{ href: urlEnum.signUp }}>
          <PrimaryButton isSmall={isButtonSmall} textProps={{ i18nKey: 'auth.sign-up.link' }} />
        </PlcAnchor>
        <SecondaryButton
          isSmall={isButtonSmall}
          onClick={() => showSignInModal()}
          textProps={{ i18nKey: 'auth.connect' }}
        />
      </div>
    </div>
  );
};

export { CommentsNotLoggedIn };
